import { NextPage } from 'next'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'

export const getStaticProps = makeLocaleStaticProps

const Page: NextPage = () => {
  return (
    <DefaultLayout
      head={{
        title: 'Mathpediaの活動を支援',
        description:
          'Mathpediaは利用者の皆様の支援で成り立っております。Paypalによる寄付やお客様の負担がないAmazonの購入による支援も受け付けております。',
      }}
      categoriesMenu={{ pc: true, sp: true, spFixed: true }}
      leftSidebar
      rightSideBar
    >
      <div className="mathdown-monotone">
        <h1>Mathpediaの活動を支援</h1>
        <p>
          Mathpediaの活動は皆様からの支援(寄付)により成り立っております。支援する方法としては、Paypalによる決済をご用意しております。なお、こちらの寄付に関しては現時点では返礼品などの特典は用意しておりません。
        </p>
        <h2>Paypalによる寄付</h2>
        <p>
          1度きりの支援（任意の金額）と毎月定額を支援する方法を用意しております。
        </p>
        <ul>
          <li>
            <a
              rel="nofollow"
              className="external text"
              href="https://www.paypal.com/paypalme/mathpedia?locale.x=ja_JP"
            >
              任意の金額(1回限り)
            </a>
          </li>
          <li>
            <a
              rel="nofollow"
              className="external text"
              href="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-1CA60197AN9882646MBNNZEQ"
            >
              毎月応援(月額1,000円)
            </a>
          </li>
          <li>
            <a
              rel="nofollow"
              className="external text"
              href="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-9FU58741NJ1739248MBNOSTA"
            >
              毎月応援(月額3,000円)
            </a>
          </li>
          <li>
            <a
              rel="nofollow"
              className="external text"
              href="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-5NS80757172117922MBNO25Y"
            >
              毎月応援(月額5,000円)
            </a>
          </li>
          <li>
            <a
              rel="nofollow"
              className="external text"
              href="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-52N52818U6300643LMBNOXDQ"
            >
              毎月応援(月額10,000円)
            </a>
          </li>
          <li>
            <a
              rel="nofollow"
              className="external text"
              href="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3G8001626A911901RMBNO2QI"
            >
              毎月応援(月額100,000円)
            </a>
          </li>
        </ul>
      </div>
    </DefaultLayout>
  )
}

export default Page
